import { render, staticRenderFns } from "./500.vue?vue&type=template&id=299b425a&scoped=true&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=299b425a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b425a",
  null
  
)

export default component.exports